export default __webpack_public_path__ + "static/media/Dorrit.f09e6108.png";